/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import DescriptionPopover from '@/components/DescriptionPopover';
import { FontAwesomeIcon } from '@/components/Icon';
import * as models from '@/models';
import { UserStore } from '@/store';
import * as utils from '@/utils';
const DisplayName = tsx.component({
    name: 'user-diplay-name',
    functional: true,
    props: {
        user: p.ofType().required,
        anonymizeFor: p.ofType().required,
    },
    /**
     * Render the display name component.
     *
     * @param h The way to create elements.
     * @param ctx The context of the component.
     * @returns A node containing the display name of the user.
     */
    render(h, ctx) {
        const assignment = ctx.props.anonymizeFor;
        const user = ctx.props.user;
        return user.getDisplayName(assignment, false).caseOf({
            Just: content => h(user.shouldAnonymize(assignment) ? 'i' : 'span', {
                class: ctx.data.class,
                staticClass: ctx.data.staticClass,
                staticStyle: ctx.data.staticStyle,
                style: ctx.data.style,
            }, content),
            Nothing: () => (<i class={[ctx.data.class, ctx.data.staticClass]} style={[ctx.data.style, ctx.data.staticStyle]}>
                    Unknown
                </i>),
        });
    },
});
export default tsx.component({
    name: 'user',
    functional: true,
    props: {
        user: p.ofType().validator(u => u instanceof models.User).required,
        beforeGroup: p(String).default('Group'),
        showTitle: p(Boolean).default(false),
        showWhenYou: p.ofType().default(undefined),
        showYou: p(Boolean).default(false),
        anonymizeFor: p.ofType().optional,
        withUsername: p(Boolean).default(false),
        hideMembers: p(Boolean).default(false),
        inline: p(Boolean).default(false),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const ownId = UserStore.id();
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderUser = (user) => {
            const isSelf = user.id === ownId;
            return [
                utils.ifExpr(ctx.props.showWhenYou != null && isSelf, () => ctx.props.showWhenYou, () => [
                    <DisplayName user={user} anonymizeFor={ctx.props.anonymizeFor} class="name-user text-break"/>,
                    utils.ifOrEmpty(ctx.props.showYou && isSelf, () => (<span class="user-you-text font-italic"> (You)</span>)),
                    utils.ifOrEmpty(ctx.props.withUsername, () => (<span class="user-username"> ({user.username})</span>)),
                ]),
                utils.ifOrEmpty(user.is_test_student, () => (<FontAwesomeIcon icon={faTriangleExclamation} class="ml-2" tabindex={0} v-b-popover_top_hover_focus={'This student is a test student.'}/>)),
            ];
        };
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderGroupMember = (member) => <li>{renderUser(member)}</li>;
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderGroup = (user) => [
            <span class="group-name">
                {ctx.props.beforeGroup} "
                <DisplayName user={user} anonymizeFor={ctx.props.anonymizeFor}/>"
            </span>,
            utils.ifOrEmpty(!ctx.props.hideMembers, () => (<DescriptionPopover triggers={['click', 'blur']} hug-text span-title="Click to show the users of this group" boundary="window" title="Group members" icon={faUserPlus}>
                    {utils.ifExpr(user.group.members.length > 0, () => (<ul class="users-list mb-0 ml-0 pl-3">
                                {user.group.members.map(renderGroupMember)}
                            </ul>), () => 'This group has no members.')}
                </DescriptionPopover>)),
        ];
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderInner = (user) => {
            if (user instanceof models.GroupUser) {
                return renderGroup(user);
            }
            else {
                return renderUser(user);
            }
        };
        let title;
        if (ctx.props.showTitle || ctx.props.user.name.isNothing()) {
            title = ctx.props.user
                .getDisplayName(ctx.props.anonymizeFor)
                .orDefault('We are not allowed permanently store the name of the user, and we cannot retrieve the name of this user anymore.');
        }
        return (<span class={[
                'user',
                ctx.props.inline ? 'd-inline' : 'd-inline-block',
                ctx.data.class,
                ctx.data.staticClass,
            ]} title={title}>
                {renderInner(ctx.props.user)}
            </span>);
    },
});
